module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.2313/img/screenshot-og.png"